import { z } from 'zod';
import { UserActivityType } from '../../entities/userActivity';

// Input schemas for recording activities

export const RecordActivityInputSchema = z.object({
    activityType: z.nativeEnum(UserActivityType),
    resourceId: z.string().optional(),
    metadata: z.record(z.any()).optional(),
});

export const GetUserActivitySummaryInputSchema = z.object({
    userId: z.string().optional(), // Optional - defaults to current user
});

export const GetResourceStatsInputSchema = z.object({
    activityType: z.nativeEnum(UserActivityType),
    resourceId: z.string(),
});

export const GetActivityTypeStatsInputSchema = z.object({
    activityType: z.nativeEnum(UserActivityType),
});

export const GetTopResourcesInputSchema = z.object({
    activityType: z.nativeEnum(UserActivityType),
    limit: z.number().int().positive().max(100).default(10),
});

// Output schemas

export const UserActivitySchema = z.object({
    _id: z.string(),
    userId: z.string(),
    activityType: z.nativeEnum(UserActivityType),
    resourceId: z.string().optional(),
    count: z.number(),
    lastActivityAt: z.string(), // ISO date string
    metadata: z.record(z.any()).optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});

export const ActivityItemSchema = z.object({
    resourceId: z.string().optional(),
    count: z.number(),
    lastViewedAt: z.string(), // ISO date string
});

export const UserActivitySummarySchema = z.object({
    appOpens: z.number(),
    quizResultViews: z.array(ActivityItemSchema),
    videoViews: z.array(ActivityItemSchema),
    campusResourceViews: z.array(ActivityItemSchema),
});

export const ResourceStatsSchema = z.object({
    totalCount: z.number(),
    uniqueUsers: z.number(),
    averageCountPerUser: z.number(),
});

export const ActivityTypeStatsSchema = z.object({
    totalCount: z.number(),
    uniqueUsers: z.number(),
    averageCountPerUser: z.number(),
});

export const TopResourceSchema = z.object({
    resourceId: z.string(),
    totalCount: z.number(),
    uniqueUsers: z.number(),
});

export const TopResourcesResponseSchema = z.object({
    resources: z.array(TopResourceSchema),
});

export const RecordActivityResponseSchema = z.object({
    success: z.boolean(),
    activity: UserActivitySchema,
});
